import type { CSSProperties } from "react";
import { type IconName, icons } from "../assets/icons";

export type { IconName } from "../assets/icons";

export type Size = 10 | 12 | 16 | 24 | 32 | 36 | 44;

type Props = {
  name: IconName;
  size?: Size;
  color?: string;
  style?: CSSProperties;
};

export function Icon({
  name,
  size = 16,
  color = "currentColor",
  style,
}: Props) {
  const url = icons[name];
  if (!url) return null;

  const mask = `url("${url}") no-repeat center / contain`;

  return (
    <span
      style={{
        display: "inline-block",
        width: size,
        height: size,
        backgroundColor: color,
        WebkitMask: mask,
        mask: mask,
        ...style,
      }}
    />
  );
}
